import React, { Component } from 'react';
import './DatiCliente.css';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import ClientiService from '../../services/Api/Utenti/UtentiApi.js';
import Dialog from 'react-bootstrap-dialog';

import link from './linkage.js';

export default class DatiClienteComponent extends Component {
  state = {
    id: '',
    codfid: '',
    nominativo: '',
    cognome: '',
    indirizzo: '',
    comune: '',
    cap: '',
    prov: '',
    telefono: '',
    mail: '',
    attivo: true,
    cards: null,

    okMsg: null,
    errMsg: null,
    clie: [],
  };
  // imports and window.counter definition omitted

  componentDidMount(props) {
    console.log('props : ', props);

    let id = this.props.match.params.codfid;
    console.log('xxxx: ', link.getValue());
    console.log('id : ', this.props.clie);
    //this.state.clie = link.getValue().clienti;
    this.setState({
      clie: link.getValue().clienti,
    });
    debugger;
    console.log('this.state.clie: ', link.getValue());

    this.setState({ clie: link.getValue().clienti });
    setTimeout(() => {
      this.handleResponse(this.state.clie);
    }, 1000);

    if (id !== -1) {
      // ClientiService.getClienteByCode(this.props.match.params.codfid)
      //   .then((response) => this.handleResponse(response))
      //   .catch((error) => this.handleError(error));
    }
  }
  initData = (values) => {
    this.setState({
      id: '',
      codfid: '',
      nominativo: '',
      cognome: '',
      indirizzo: '',
      comune: '',
      cap: '',
      prov: '',
      telefono: '',
      mail: '',
      attivo: true,
      cards: null,
    });
  };
  handleResponse = (response) => {
    console.log('rew ', response);
    this.setState({
      id: response.id,
      codfid: response.id,
      nominativo: response.nome,
      cognome: response.cognome,
      //   indirizzo: response.data.indirizzo,
      //   comune: response.data.comune,
      //   cap: response.data.cap,
      //   prov: response.data.prov,
      telefono: response.telefono,
      mail: response.email,
      //   attivo: response.data.attivo,
      //   cards: response.data.cards,
    });
  };

  handleError = (error) => {
    console.log('errore', error.response.data.message);

    this.setState({ errMsg: error.response.data.message });
  };

  Salva = (values) => {
    console.log(values);
    this.setState({ errMsg: '', okMsg: '' });
    ClientiService.insUtente({
      id: values.id,
      codfid: values.codfid,
      nominativo: values.nominativo,
      cognome: values.cognome,
      indirizzo: values.indirizzo,
      comune: values.comune,
      cap: values.cap,
      prov: values.prov,
      telefono: values.telefono,
      mail: values.mail,
      attivo: values.attivo,
      cards: this.state.cards,
    })
      .then(() => {
        this.setState({ okMsg: 'Inserimento dati eseguito con successo' });
        console.log(this.state.okMsg);
        values.id = '';
        values.codfid = '';
        values.nominativo = '';
        values.cognome = '';
        values.indirizzo = '';
        values.comune = '';
        values.cap = '';
        values.prov = '';
        values.telefono = '';
        values.mail = '';
        this.initData();
      })
      .catch((error) => this.handleError(error));
  };

  Valida = (values) => {
    let errors = {};

    // if (!values.codfid) {
    //   errors.codfid = 'Inserisci il codice fidelity del cliente';
    // } else if (values.codfid.length !== 8) {
    //   errors.codfid = 'Il codice fidelity deve avere 8 caratteri';
    // }

    if (!values.nominativo) {
      errors.nominativo = 'Inserisci il nome';
    } else if (values.nominativo.length < 6) {
      errors.nominativo = 'Il nome deve avere almeno 3 caratteri';
    }
    if (!values.cognome) {
      errors.cognome = 'Inserisci il cognome';
    } else if (values.cognome.length < 3) {
      errors.cognome = 'Il cognome deve avere almeno 3 caratteri';
    }

    if (!values.indirizzo) {
      errors.indirizzo = "Inserisci l'indirizzo";
    } else if (values.indirizzo.length < 8) {
      errors.indirizzo = "L'indirizzo deve avere almeno 8 caratteri";
    }

    if (!values.comune) {
      errors.comune = 'Inserisci il comune di residenza';
    }

    if (!values.telefono) {
      errors.telefono = 'Inserisci il numero di telefono';
    } else if (values.telefono.length < 5) {
      errors.telefono = 'Il numero di telefono deve avere almeno 5 caratteri';
    }

    return errors;
  };
  inc = (x) => {
    console.log('object');
  };
  CancelAction = (x) => {
    console.log('CancelAction ', x);
  };
  OKAction = () => {
    console.log('Cancel was clicked!');
    this.props.history.push(`/utente`);
  };
  Annulla = () => {
    console.log('Cliente annullato');
    //this.dialog.showAlert('Hello Dialog!');

    this.dialog.show({
      title: 'Greedings',
      body: 'How are you?',
      actions: [
        Dialog.CancelAction(this.CancelAction),
        Dialog.OKAction(this.OKAction),
      ],
      bsSize: 'small',
      onHide: (dialog) => {
        //dialog.hide();
        console.log('closed by clicking background.');
      },
    });

    // if (window.confirm('Abbandoni il caricamento?')) {
    //   this.props.history.push(`/utente`);
    // }
  };

  render() {
    let {
      id,
      codfid,
      nominativo,
      cognome,
      indirizzo,
      comune,
      cap,
      prov,
      telefono,
      mail,
      attivo,
    } = this.state;
    return (
      <section className='container py-4'>
        <div className='card py-4'>
          <div className='card-body'>
            <h3 className='card-title mb-4'>Dati Utente</h3>
            <AlpineWidget />
            <Dialog
              ref={(el) => {
                this.dialog = el;
              }}
            />
            <Formik
              initialValues={{
                id,
                codfid,
                nominativo,
                cognome,
                indirizzo,
                comune,
                cap,
                prov,
                telefono,
                mail,
                attivo,
              }}
              onSubmit={this.Salva}
              enableReinitialize={true}
              validate={this.Valida}
              validateOnChange={true}
              validateOnBlur={false}
            >
              {(props) => (
                <Form>
                  <div className='form-group'>
                    <img
                      src={`../user.png`}
                      className='img-sm rounded-circle border'
                      alt='imgcli'
                    />
                  </div>

                  {this.state.okMsg && (
                    <div className='alert alert-success'>
                      <h5>{this.state.okMsg}</h5>
                    </div>
                  )}
                  {this.state.errMsg && (
                    <div className='alert alert-danger'>
                      <h5>{this.state.errMsg}</h5>
                    </div>
                  )}

                  <div className='form-row'>
                    <div className='col form-group'>
                      <label>Codice Fidelity *</label>
                      <Field
                        type='text'
                        name='codfid'
                        className='form-control'
                      />
                      <ErrorMessage
                        name='codfid'
                        component='span'
                        className='errmsg'
                      />
                    </div>
                    <div className='col form-group'>
                      <label>Nominativo (Nome ) *</label>
                      <Field
                        type='text'
                        name='nominativo'
                        className='form-control'
                      />
                      <ErrorMessage
                        name='nominativo'
                        component='span'
                        className='errmsg'
                      />
                    </div>

                    <div className='col form-group'>
                      <label>Cognome *</label>
                      <Field
                        type='text'
                        name='cognome'
                        className='form-control'
                      />
                      <ErrorMessage
                        name='cognome'
                        component='span'
                        className='errmsg'
                      />
                    </div>
                  </div>

                  <div className='form-row'>
                    <div className='col form-group'>
                      <label>Indirizzo</label>
                      <Field
                        type='text'
                        name='indirizzo'
                        className='form-control'
                      />
                      <ErrorMessage
                        name='indirizzo'
                        component='span'
                        className='errmsg'
                      />
                    </div>
                  </div>

                  <div className='form-row'>
                    <div className='col form-group'>
                      <label>Comune</label>
                      <Field
                        type='text'
                        name='comune'
                        className='form-control'
                      />
                      <ErrorMessage
                        name='comune'
                        component='span'
                        className='errmsg'
                      />
                    </div>
                    <div className='col form-group'>
                      <label>Cap</label>
                      <Field type='text' name='cap' className='form-control' />
                    </div>
                    <div className='col form-group'>
                      <label>Provincia</label>
                      <Field as='select' name='prov' className='form-control'>
                        <option value=''>Seleziona...</option>
                        <option value='CT'>Catania</option>
                        <option value='SR'>Siracusa</option>
                        <option value='RG'>Ragusa</option>
                        <option value='ME'>Messina</option>
                        <option value='PA'>Palermo</option>
                      </Field>
                    </div>
                  </div>

                  <div className='form-row'>
                    <div className='col form-group'>
                      <label>Telefono</label>
                      <Field
                        type='text'
                        name='telefono'
                        className='form-control'
                      />
                      <ErrorMessage
                        name='telefono'
                        component='span'
                        className='errmsg'
                      />
                    </div>
                    <div className='col form-group'>
                      <label>Mail</label>
                      <Field
                        type='email'
                        name='mail'
                        className='form-control'
                      />
                    </div>
                  </div>

                  <div className='form-row'>
                    <label className='custom-control custom-checkbox'>
                      <Field
                        type='checkbox'
                        name='attivo'
                        className='custom-control-input'
                      />
                      <div className='custom-control-label'> Attivo </div>
                    </label>
                  </div>

                  <div>
                    <button type='submit' className='btn btn-primary inscli'>
                      Salva
                    </button>
                    <button
                      type='button'
                      onClick={this.Annulla}
                      className='btn btn btn-warning inscli m-2'
                    >
                      Annulla
                    </button>
                  </div>
                  <hr />
                  <p className='text-muted'>
                    Confermando l'inserimento dei dati si accettano le politiche
                    di privacy
                  </p>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </section>
    );
  }
}
//  dialogTemplate
const AlpineWidget = () => (
  <div dangerouslySetInnerHTML={{ __html: alpineTemplate }} />
);
const alpineTemplate = `<div x-data="counter()">
<button @click="inc()">Increment</button>
<p x-text="count"></p>
</div>`;
// http://localhost:3000/insutente/3
// http://127.0.0.1:5501/cancello
// https://alpinetoolbox.com/examples/modal
window.counter = function () {
  return {
    count: 0,
    inc() {
      this.count += 1;
    },
  };
};
// const dialogTemplate = `
// <div className="overflow-auto" style="background-color: rgba(0,0,0,0.5)" x-show="showModal" :class="{ 'absolute inset-0 z-10 flex items-center justify-center': showModal }">

//   <div className="bg-white w-11/12 md:max-w-md mx-auto rounded shadow-lg py-4 text-left px-6" x-show="showModal" @click.away="showModal = false" x-transition:enter="ease-out duration-300" x-transition:enter-start="opacity-0 scale-90" x-transition:enter-end="opacity-100 scale-100" x-transition:leave="ease-in duration-300" x-transition:leave-start="opacity-100 scale-100" x-transition:leave-end="opacity-0 scale-90">

//     <div className="flex justify-between items-center pb-3">
//       <p className="text-2xl font-bold">Simple Modal!</p>
//       <div className="cursor-pointer z-50" @click="showModal = false">
//         <svg className="fill-current text-black" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
//           <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path>
//         </svg>
//       </div>
//     </div>

//     <!-- content -->
//     <p>Modal content can go here</p>
//     <p>...</p>
//     <p>...</p>
//     <p>...</p>
//     <p>...</p>

//     <!--Footer-->
//     <div className="flex justify-end pt-2">
//       <button className="px-4 bg-transparent p-3 rounded-lg text-indigo-500 hover:bg-gray-100 hover:text-indigo-400 mr-2" @click="alert('Additional Action');">Action</button>
//       <button className="modal-close px-4 bg-indigo-500 p-3 rounded-lg text-white hover:bg-indigo-400" @click="showModal = false">Close</button>
//     </div>

//   </div>

// </div>
// `;

